// extracted by mini-css-extract-plugin
export var dropdownButton = "_1m-0";
export var fullWidthDropdownButton = "_1m-1";
export var icon = "_1m-3";
export var iconPlaceholder = "_1m-2";
export var shortcutContainer = "_1m-4";